export const ROLE_SEARCH = "ROLE_SEARCH";
export const ROLE_SEARCH_RESPONSE = "ROLE_SEARCH_RESPONSE";
export const ROLE_GET = "ROLE_GET";
export const ROLE_GET_RESPONSE = "ROLE_GET_RESPONSE";
export const ROLE_CREATE = "ROLE_CREATE";
export const ROLE_CREATE_RESPONSE = "ROLE_CREATE_RESPONSE";
export const ROLE_UPDATE = "ROLE_UPDATE";
export const ROLE_UPDATE_RESPONSE = "ROLE_UPDATE_RESPONSE";
export const ROLE_DELETE = "ROLE_DELETE";
export const ROLE_DELETE_RESPONSE = "ROLE_DELETE_RESPONSE"